<template>
<router-link class="grid__item" active-class="grid__item--active" :to="to">
    <div class="grid__item__icon">
        <slot name="icon"></slot>
    </div>
    <p class="grid__item__text">
        <span>{{ text }}</span>
    </p>
</router-link>
</template>

<script>
export default {
  name: 'GridItem',

  props: {
    text: {
      type: String,
      default: ''
    },

    to: {
      type: [String, Object],
      default: ''
    }
  },

  methods: {
    onClick() {
      const {
        to,
        $router
      } = this

      if (to && $router) {
        $router.push(to)
      }

      this.$emit('on-item-click')
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/index.less';

.grid__item {

    width: 48%;
    position: relative;
    padding:5px 0px;
    display: flex;
    align-items: center;

    &--active &__text {
        color: #dc2733;
    }

    // &__icon {
    //     width: 100px;
    //     height: 100px;
    // }

    &__text {
        text-align: center;
        color: #221917;
        font-size: 15px;
        margin-left: 5px;
        display: flex;
        // align-items: center;
    }
}
</style>
